/**
 * Papier Royal — Carnet à vis : mécanique panier (Lot 2 / §2 du brief).
 *
 * DEUX briques, aucune modification des fichiers Horizon coeur :
 *   1. ATC ATOMIQUE  — window.PRCarnet.add(composition) : les 6 lignes (1 couverture
 *      + 5 blocs) ajoutées en UN SEUL POST /cart/add.js {items:[…]}. Appelé par le
 *      configurateur (§3) et par « Ajouter tel quel » des presets.
 *   2. SUPPRESSION ATOMIQUE (Option B, notre code de bout en bout — PAS de Customily
 *      ici) : clic sur le remove d'une ligne carnet → on intercepte, capture FRAÎCHE
 *      de /cart.js, résolution des 6 clés par _pr-carnet-id, UN SEUL /cart/update.js
 *      (toutes à 0), relance unique sur 422, fail-open (reload) si ça résiste.
 *
 * Le regroupement VISUEL (couverture en-tête, blocs « Inclus ») est fait en Liquid
 * dans snippets/cart-products.liquid (flags pr_is_bundle_head / pr_is_grouped_service
 * généralisés à _pr-carnet-id) + data-carnet-id / data-carnet-role sur chaque <tr>.
 *
 * Refresh du drawer : on réutilise le contrat maison éprouvé (cart-companions.js) —
 * dispatch d'un CustomEvent 'cart:update' avec la shape attendue par Atelier
 * (event.detail.data.sections). Le filet serveur reste la Function v11 (checkout).
 */
(function () {
  'use strict';

  var CID_PROP = '_pr-carnet-id';
  var ROLE_PROP = '_pr-carnet-role';
  var FMT_PROP = '_pr-carnet-format';

  function log() {
    if (window.PR_CARNET_DEBUG && window.console) console.log.apply(console, ['[pr-carnet]'].concat([].slice.call(arguments)));
  }

  // Racine localisée (ex. '/fr/' sur ce store). SANS ça, /cart/update.js sur une page
  // /fr/… tape la mauvaise route → la suppression atomique échoue. Shopify.routes.root
  // finit toujours par '/'.
  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path; // ex. '/fr/' + 'cart/update.js'
  }

  // UUID v4 léger (crypto si dispo, sinon fallback). Sert de clé de groupe.
  function genUuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'cav-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  // Sections morphables (drawer + header), pour que Horizon re-morphe après mutation.
  function getMorphableSections() {
    var sections = new Set();
    document.querySelectorAll('[data-section-id], [id^="shopify-section-"]').forEach(function (el) {
      var id = el.dataset.sectionId || el.id.replace('shopify-section-', '');
      if (id && (el.querySelector('cart-drawer-component') || el.querySelector('cart-items-component') || id.indexOf('header') !== -1)) {
        sections.add(id);
      }
    });
    return Array.from(sections).join(',');
  }

  // Dispatch du refresh panier, shape attendue par component-cart-items.js.
  function dispatchCartUpdate(data, source) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: data,
        sourceId: source || 'pr-carnet',
        data: { sections: data && data.sections, source: source || 'pr-carnet', itemCount: data && data.item_count }
      }
    }));
  }

  // ── BRIQUE 1 : ATC atomique ────────────────────────────────────────────────
  /**
   * @param {Object} c composition
   *   c.format         : 'A4' | 'A5' | 'A6'
   *   c.qty            : nombre de carnets (défaut 1) — appliqué aux 6 lignes
   *   c.cover          : { id: <variantId>, sku?, title? }
   *   c.blocs          : [ { id: <variantId>, sku? }, … ] (exactement 5 attendus)
   *   c.compositionText: libellé lisible ("Seine bleu · 5 blocs lignés Seine sur papier Bleu")
   * @returns {Promise<Object>} la réponse /cart/add.js
   */
  async function add(c) {
    if (!c || !c.cover || !c.cover.id || !Array.isArray(c.blocs)) {
      throw new Error('[pr-carnet] composition invalide (cover + blocs requis)');
    }
    if (c.blocs.length !== 5) {
      // On n'ajoute JAMAIS un carnet incomplet côté client (la Function v11 bloquerait
      // au checkout ; autant échouer tôt et clairement).
      throw new Error('[pr-carnet] un carnet = exactement 5 blocs (reçu ' + c.blocs.length + ')');
    }
    var uuid = c.carnetId || genUuid();
    var qty = c.qty && c.qty > 0 ? c.qty : 1;
    var fmt = c.format || '';

    // ORDRE : Shopify affiche le panier en ordre INVERSE de l'ajout (dernier ajouté en
    // tête). On ajoute donc les 5 blocs D'ABORD, la couverture EN DERNIER → la couverture
    // remonte en en-tête du groupe (exigence §2.2 : couverture = en-tête).
    var items = [];
    c.blocs.forEach(function (b, i) {
      // Le rôle distinct bloc-1..bloc-5 rend chaque ligne UNIQUE même si SKU identique
      // (mode « 5 blocs identiques ») → Shopify ne fusionne pas les 5 lignes.
      var p = {};
      p[CID_PROP] = uuid;
      p[ROLE_PROP] = 'bloc-' + (i + 1);
      p[FMT_PROP] = fmt;
      items.push({ id: Number(b.id), quantity: qty, properties: p });
    });
    items.push({
      id: Number(c.cover.id),
      quantity: qty,
      properties: (function () {
        var p = {};
        p[CID_PROP] = uuid;
        p[ROLE_PROP] = 'couverture';
        p[FMT_PROP] = fmt;
        if (c.compositionText) p['Composition'] = c.compositionText; // propriété VISIBLE (récap client/atelier)
        return p;
      })()
    });

    log('add', uuid, fmt, 'qty', qty, items);
    var res = await fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: getMorphableSections(), sections_url: window.location.pathname })
    });
    if (!res.ok) {
      var txt = '';
      try { txt = await res.text(); } catch (e) {}
      throw new Error('[pr-carnet] /cart/add.js a échoué (' + res.status + ') ' + txt);
    }
    var data = await res.json();
    dispatchCartUpdate(data, 'pr-carnet-add');
    return data;
  }

  // ── BRIQUE 2 : suppression atomique du groupe (Option B) ────────────────────
  async function removeGroup(carnetId) {
    async function attempt() {
      // Capture FRAÎCHE : Shopify réordonne/rekey le panier, on ne se fie jamais au DOM.
      var cart = await fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      var updates = {};
      var n = 0;
      cart.items.forEach(function (it) {
        var props = it.properties || {};
        if (props[CID_PROP] === carnetId) { updates[it.key] = 0; n++; }
      });
      log('removeGroup: lignes du groupe trouvées =', n);
      if (n === 0) return { done: true, data: cart }; // déjà supprimé → rien à faire
      var res = await fetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: getMorphableSections(), sections_url: window.location.pathname })
      });
      return { done: res.ok, status: res.status, res: res };
    }

    try {
      var r = await attempt();
      if (r.status === 422) { log('422 → relance unique'); r = await attempt(); } // relance unique
      if (r.done) {
        var data = r.data || (r.res ? await r.res.json() : null);
        if (data) dispatchCartUpdate(data, 'pr-carnet-remove');
        else dispatchCartUpdate({ sections: null }, 'pr-carnet-remove');
        return;
      }
      throw new Error('update.js status ' + r.status);
    } catch (e) {
      // fail-open : on ne laisse jamais l'utilisateur coincé — reload propre du panier.
      log('removeGroup fail-open', e);
      window.location.reload();
    }
  }

  // Interception : préempte à la fois le on:click="/onLineItemRemove/N" de Horizon ET
  // l'intercepteur anti-orphelin NATIF de Customily (« Intercepting clicks for upsell »,
  // cf. mémoire customily-native-upsell-coupling). Customily écoute en capture sur DOCUMENT ;
  // on écoute donc sur WINDOW en capture, qui s'exécute AVANT tout listener document-capture
  // → on gagne la course et on bloque les deux. Uniquement pour les lignes carnet
  // (data-carnet-id présent) ; tous les autres removes suivent leur flux natif intact.
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cart-items__remove') : null;
    if (!btn) return;
    // Exclut les groupes « initiales » : ils ont leur propre suppression atomique dans
    // pr-initiales.js. Sans ce filtre, les deux scripts se disputent le même clic.
    var row = btn.closest('[data-carnet-id]:not([data-group-source="init"])');
    log('remove click vu; ligne carnet ?', !!row);
    if (!row) return; // pas une ligne carnet → laisser Horizon/Customily gérer
    var carnetId = row.getAttribute('data-carnet-id');
    if (!carnetId) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // bloque Horizon (retrait 1 ligne) ET Customily (anti-orphelin)
    log('remove group', carnetId, 'via role', row.getAttribute('data-carnet-role'));
    removeGroup(carnetId);
  }, true); // ← WINDOW capture (avant document-capture de Customily)

  // ── API publique ────────────────────────────────────────────────────────────
  window.PRCarnet = { add: add, removeGroup: removeGroup, _genUuid: genUuid };
  log('ready');
})();
